import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';

@Component({
  selector: 'tt-create-po-pu',
  templateUrl: './create-po-pu.component.html',
  styleUrls: ['./create-po-pu.component.css']
})
export class CreatePoPuComponent implements OnInit {
    stockKeyno;

    public edit?: Edit;

    public creating = false;

    public productIdButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'product', gotoParms: () => this.edit!.prod_id ?? '' }
    ];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.stockKeyno = this.stateService.getStateParams()['stock_keyno'];
    }

    private async loadEdit() {
        if (!!this.stockKeyno) {
            this.edit = (await this.datatask.Post(228, { stock_keyno: this.stockKeyno }))[0];
        }
    }

    public async createChanges() {
        if (!!this.edit) {
            try {
                this.creating = true;

                await this.datatask.Post(229, this.edit);

                this.stateService.back();
            } finally {
                this.creating = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    stock_keyno: number;
    stockplace_name: string;
    prod_id: string;
    prod_name: string;
    quantity: string;
    create_text: string;
}
